// Konfiguracja aplikacji
export const appConfig = {
    version: '1.1.1',
    name: 'Poker Timer',
    description: 'Aplikacja do śledzenia czasu i blindów podczas gry w pokera'
};

export default appConfig;